import { render, staticRenderFns } from "./InventoryTQChart.vue?vue&type=template&id=5f20f580&scoped=true&"
import script from "./InventoryTQChart.vue?vue&type=script&lang=js&"
export * from "./InventoryTQChart.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTQChart.vue?vue&type=style&index=0&id=5f20f580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f20f580",
  null
  
)

export default component.exports